exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.loading[data-v-6a42ef44], button.success[data-v-6a42ef44] {\n  padding: 13px 25px;\n}\nbutton[data-v-6a42ef44]:disabled {\n  pointer-events: none;\n}\nbutton .checkmark[data-v-6a42ef44] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20px;\n  margin-left: 15px;\n}\nbutton .checkmark[data-v-6a42ef44]::after {\n  content: \"\";\n  display: block;\n  width: 10px;\n  height: 18px;\n  margin-top: -10px;\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}", ""]);

// exports
